import SEOLocaleList from '@apps/components/SEOLocaleList';
import { BASE_URL } from '@apps/config';
import { getRanking } from '@apps/config/API/new-car.config';
import CarRankingScreen from '@apps/screens/CarRankingScreen';
import createBasePath from '@stack/helpers/lib/createBasePath';
import Breadcrumb from '@stack/ui/components/Breadcrumb';
import { BreadCrumbOptions } from '@stack/ui/components/Breadcrumb/props';
import { NextPage, NextPageContext } from 'next';
import { useRouter } from 'next/router';
import { NextSeo, NextSeoProps } from 'next-seo';

/**
 * ===========================
 * MAIN
 * ===========================
 */
const Page: NextPage = (props) => {
  const { data, webView, settings } = props;
  // ============ HOOKS
  const router = useRouter();
  const { basePath } = createBasePath({ webView, type: 'cars' });

  // ============ VARIABLES
  const breadcrumbOpt: BreadCrumbOptions[] = [
    {
      title: 'AutoFacts',
      url: `${basePath}`,
    },
    {
      title: 'Ranking',
      url: '',
    },
  ];

  const popularBrand = settings.car_brand_featured;
  const currentUrl = `${BASE_URL}${router?.asPath}`;
  const canonicalPath = currentUrl.split('?')[0].toLowerCase();
  const nextSeoProps: NextSeoProps = {
    defaultTitle:
      'Top Car Rankings in Malaysia: Best-Selling Models & Brands | Carz Automedia Malaysia',
    description:
      'Discover the top car rankings in Malaysia, including best-selling models, leading brands, and the most-searched cars. Stay updated on market trends and insights with Carz Automedia Malaysia.',
    canonical: canonicalPath,
  };

  // ============ VIEWS
  return (
    <>
      {!webView && <NextSeo {...nextSeoProps} />}
      <SEOLocaleList />
      {!webView && <Breadcrumb options={breadcrumbOpt} bold />}
      <CarRankingScreen
        webView={webView}
        popularBrand={popularBrand}
        data={data}
        location_city={settings.location_city}
        location_state={settings.location_state}
      />
    </>
  );
};

/**
 * ===========================
 * SERVER SIDE RENDERING
 * ===========================
 */
export async function getServerSideProps(ctx: NextPageContext) {
  const data = await getRanking();
  return {
    props: {
      data,
    },
  };
}

/**
 * ===========================
 * EXPORT
 * ===========================
 */
export default Page;
